import React, { Component } from "react";

import SideTabs from "./SideTabs";
import DataTable from "./DataTable";

import db from "../../../../services/query";

class DailyReport extends Component {
  state = {
    currentTab: "",
    selectedDate: "",
    data: [],
    type: "",
    summary: [],
    balancePrintPath: "dailyReport/balance",
    transactionPrintPath: "dailyReport",
  };

  componentDidMount = async () => {
    let today = new Date();

    let dd = String(today.getDate()).padStart(2, "0");
    let mm = String(today.getMonth() + 1).padStart(2, "0");
    let yyyy = today.getFullYear();

    today = `${yyyy}-${mm}-${dd}`;

    await db
      .getAll(`dashboard/finance/daily?date=${today}`)
      .then(({ data }) => {
        this.setState({
          data: data.data[0],
          summary: data.summary,
          selectedDate: today,
        });
      });
  };

  handleCurrentTab = (currentTab, type) => {
    let transactionPrintPath = `dailyReport/transactions/${type}/${currentTab?.id}`;

    this.setState({ currentTab, type, transactionPrintPath });
  };

  handleDateChange = async ({ target }) => {
    const { currentTab, type } = this.state;

    let transactionPrintPath = `dailyReport/transactions/${type}/${currentTab?.id}/${target.value}`;

    let balancePrintPath = `dailyReport/balance/${target.value}`;

    await db
      .getAll(`dashboard/finance/daily?date=${target.value}`)
      .then(({ data }) => {
        this.setState({
          data: data.data[0],
          summary: data.summary,
          selectedDate: target.value,
          balancePrintPath,
          transactionPrintPath,
        });
      });
  };

  getUpdatedData = () => {
    const { data, type, currentTab } = this.state;

    let _data = data[type];

    if (type == "expenses") {
      _data = _data.filter((row) => row.expense_type_id === currentTab.id);
    }

    if (type == "revenues") {
      _data = _data.filter((row) => row.revenue_type_id === currentTab.id);
    }

    return { data: _data };
  };

  render() {
    const {
      summary,
      currentTab,
      selectedDate,
      balancePrintPath,
      transactionPrintPath,
    } = this.state;
    const { data } = this.getUpdatedData();

    return (
      <div className="daily-report-cr">
        <SideTabs
          currentTab={currentTab}
          handleCurrentTab={this.handleCurrentTab}
        />
        <DataTable
          data={data}
          summary={summary}
          currentTab={currentTab}
          selectedDate={selectedDate}
          balancePrintPath={balancePrintPath}
          transactionPrintPath={transactionPrintPath}
          handleDateChange={this.handleDateChange}
        />
      </div>
    );
  }
}

export default DailyReport;
